import React from 'react';
import "../assets/scss/components/layout.scss";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import Content from "./Content";

const Layout = ({ children, ...props }) => {
    return children;
};

export default Layout;
